module.exports = __webpack_public_path__ + "static/media/logo.3c58b3d8.svg";